import i18n from "i18n/config";
import { RouteObject } from "react-router-dom";

export const investorTransferRoutes: RouteObject = {
  id: "investorTransfers",
  path: "investor-transfers",
  children: [
    {
      id: "investorTransfersCreate",
      path: "create",
      lazy: async () => {
        const { InvestorTransferCreatePage } = await import(
          "features/investor-transfer/InvestorTransferCreatePage"
        );
        return { Component: InvestorTransferCreatePage };
      },
    },
    {
      id: "investorTransfersSetup",
      path: "setup/:investorTransferId/*",
      lazy: async () => {
        const { InvestorTransferSetupPage } = await import(
          "features/investor-transfer/setup/InvestorTransferSetupPage"
        );
        return { Component: InvestorTransferSetupPage };
      },
      children: [
        {
          id: "investorTransfersSetupDetails",
          lazy: async () => {
            const { InvestorTransferSetupDetailsPage } = await import(
              "features/investor-transfer/setup/InvestorTransferSetupDetailsPage"
            );
            return { Component: InvestorTransferSetupDetailsPage };
          },
          path: "",
          handle: {
            title: i18n.t("investorTransfer:setup.details.breadcrumb"),
          },
        },
        {
          id: "investorTransfersSetupTransferees",
          path: "transferees",
          lazy: async () => {
            const { InvestorTransferSetupTransfereesPage } = await import(
              "features/investor-transfer/setup/InvestorTransferSetupTransfereesPage"
            );
            return { Component: InvestorTransferSetupTransfereesPage };
          },
          handle: {
            title: i18n.t("investorTransfer:setup.transferees.breadcrumb"),
          },
        },
        {
          id: "investorTransfersSetupDocuments",
          path: "documents",
          lazy: async () => {
            const { InvestorTransferSetupDocumentsPage } = await import(
              "features/investor-transfer/setup/InvestorTransferSetupDocumentsPage"
            );
            return { Component: InvestorTransferSetupDocumentsPage };
          },
          handle: {
            title: i18n.t("investorTransfer:setup.documents.breadcrumb"),
          },
        },
        {
          id: "investorTransfersSetupReview",
          path: "review",
          lazy: async () => {
            const { InvestorTransferSetupReviewPage } = await import(
              "features/investor-transfer/setup/InvestorTransferSetupReviewPage"
            );
            return { Component: InvestorTransferSetupReviewPage };
          },
          handle: {
            title: i18n.t("investorTransfer:setup.review.breadcrumb"),
          },
        },
        {
          id: "investorTransfersSetupSetupFinalize",
          path: "finalize",
          lazy: async () => {
            const { InvestorTransferSetupFinalizePage } = await import(
              "features/investor-transfer/setup/InvestorTransferSetupFinalizePage"
            );
            return { Component: InvestorTransferSetupFinalizePage };
          },
          handle: {
            title: i18n.t("investorTransfer:setup.finalize.breadcrumb"),
          },
        },
      ],
    },
    {
      id: "investorTransfersView",
      path: ":investorTransferId",
      lazy: async () => {
        const { InvestorTransferViewPage } = await import(
          "features/investor-transfer/InvestorTransferViewPage"
        );
        return { Component: InvestorTransferViewPage };
      },
    },
  ],
};
